import type React from 'react';
import { useState } from 'react';

import type { BaseComponentProps } from '@coursera/cds-common';

import { ItemsCollectionProvider } from '@core/utils';

import type { CommonProps } from './ActionButton';
import ButtonsOverflow from './ButtonsOverflow';

export type Props = BaseComponentProps<'div'> & {
  /**
   * Determines the layout of the buttons within the group, either in a row or column.
   * @default 'row'
   */
  direction?: 'row' | 'column';

  /**
   * Specifies the variant of the buttons in the group.
   * @default 'secondary'
   */
  variant?: 'secondary' | 'ghost' | 'ghostInvert';

  /**
   * Sets the size of the buttons in the group.
   * @default 'medium'
   */
  size?: 'small' | 'medium';

  /**
   * Contains the individual `ActionButtonGroup.Button` components to be rendered within the group.
   *
   * @see ActionButtonGroup
   * @see ActionButtonGroup.Button
   */
  children?: React.ReactNode;
};

const ActionButtonGroup = (props: Props) => {
  const [itemsVisibility, setItemsVisibility] = useState<
    Record<string, boolean>
  >({});

  return (
    <ItemsCollectionProvider<HTMLButtonElement, CommonProps>
      commonProps={{
        variant: props.variant,
        size: props.size,
        itemsVisibility: itemsVisibility,
      }}
    >
      {(collection) => (
        <ButtonsOverflow
          collection={collection}
          setItemsVisibility={setItemsVisibility}
          {...props}
        />
      )}
    </ItemsCollectionProvider>
  );
};

export default ActionButtonGroup;
